"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAirrorPayload = exports.isAirror = void 0;
exports.matchesAirror = matchesAirror;
const lodash_1 = require("lodash");
const isAirror = (error) => (0, lodash_1.isError)(error) && 'type' in error;
exports.isAirror = isAirror;
function matchesAirror(thrown, { type }) {
    return (0, exports.isAirror)(thrown) && thrown.type === type;
}
const isAirrorPayload = (payload) => typeof payload === 'object' &&
    typeof payload.type === 'string' &&
    typeof payload.message === 'string' &&
    (typeof payload.extra === 'object' || payload.extra === undefined) &&
    (typeof payload.statusCode === 'number' || payload.statusCode === undefined);
exports.isAirrorPayload = isAirrorPayload;
//# sourceMappingURL=utils.js.map